import { Blockchain } from "@rarible/api-client"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

const injectiveViem = {
  id: 1776,
  name: "Injective EVM",
  nativeCurrency: {
    name: "Injective",
    symbol: "INJ",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ["https://sentry.evm-rpc.injective.network"],
    },
  },
  blockExplorers: {
    default: {
      name: "Injective Explorer",
      url: "https://blockscout.injective.network",
    },
  },
  testnet: false,
}

export const injectiveConfig: StaticEthereumBlockchainConfig = {
  name: "Injective",
  icon: "/images/blockchains/injective.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://injective-api.rarible.org",
  chainId: injectiveViem.id,
  blockchain: Blockchain.INJECTIVE,
  chainName: injectiveViem.name,
  exchange: {
    v2: "0x2c46e116a742C159fa79e2717b50759EC979e3Be",
    wrapper: "0x4421b444955b50e57fa2F73656A5bD1E23F9B9e5",
  },
  blockExplorers: [
    {
      url: "https://blockscout.injective.network",
      icon: "/images/scanner.svg",
      adress: "https://blockscout.injective.network/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "injective-node",
  transferProxies: {
    nft: "0x892f0e3DEaC041b12b748bf9d7D1BA480d266696",
    erc721Lazy: "0x147d06FbDA085C0455615E554D87262B0726ad0c",
    erc20: "0x12181eDedD1f81838580668bb5B50e1030df4667",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("INJECTIVE:0x0000000000000000000000000000000000000000"),
    symbol: "INJ",
    name: "Injective",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("INJECTIVE:0x0000000088827d2d103ee2d9a6b781773ae03ffb"),
    symbol: "WINJ",
    name: "Wrapped Injective",
    decimals: 18,
  },
  addFundsLink: "",
  hasStabilityProtocol: false,
  viem: injectiveViem,
}

export const getInjectiveConfig = (): StaticEthereumBlockchainConfig =>
  injectiveConfig
